import { FC, useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'

import { Checkbox, FormControlLabel, Button, Box, Typography, Divider } from '@mui/material'

import { columns } from '../../consts/consts'

interface IProps {
  data: boolean
}

const UniquenessSelector: FC<IProps> = ({ data }) => {
  const [uniqueColumns, setUniqueColumns] = useState<string[]>([])

  useEffect(() => {
    const uniquenessString = searchParams.get('uniqueness')
    const uniquenessFromUrl = uniquenessString ? uniquenessString.split(',') : []
    setUniqueColumns(uniquenessFromUrl)
  }, [])
  const handleUniqueColumnChange = (column: string, isChecked: boolean) => {
    const newUniqueColumns = isChecked
      ? [...uniqueColumns, column]
      : uniqueColumns.filter((col) => col !== column)
    setUniqueColumns(newUniqueColumns)
  }
  const [searchParams, setSearchParams] = useSearchParams()
  const setUniquenessToUrl = (uniqueness: string[]) => {
    const params = new URLSearchParams(searchParams.toString())
    if (uniqueness.length) {
      params.set('uniqueness', uniqueness.join(','))
    } else {
      params.delete('uniqueness')
    }
    params.delete('page')
    setSearchParams(params)
  }
  const resetUniqueness = () => {
    setUniquenessToUrl([])
    setUniqueColumns([])
  }
  return (
    <Box
      sx={{
        borderRadius: '14px',
        backgroundColor: '#ffffff',
        p: '14px',
        display: 'flex',
        flexDirection: 'column',
        gap: '12px',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: '14px',
        }}
      >
        <Typography sx={{ fontSize: '18px' }} gutterBottom>
          Uniqueness
        </Typography>
        <Box sx={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => setUniquenessToUrl(uniqueColumns)}
            disabled={!data}
          >
            Apply Uniqueness
          </Button>
          <Button variant="contained" color="primary" onClick={resetUniqueness} disabled={!data}>
            Reset Uniqueness
          </Button>
        </Box>
      </Box>
      <Divider />

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          gap: '16px',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: '16px',
          }}
        >
          {columns.map((column: string) => (
            <FormControlLabel
              key={column}
              disabled={!data}
              control={
                <Checkbox
                  checked={uniqueColumns.includes(column)}
                  onChange={(e) => handleUniqueColumnChange(column, e.target.checked)}
                />
              }
              label={column.split('_').map(a => a[0].toUpperCase() + a.slice(1)).join(' ')}
              sx={{
                '& .MuiFormControlLabel-label': {
                  fontSize: '12px',
                },
              }}
            />
          ))}
        </Box>
      </Box>
    </Box>
  )
}

export default UniquenessSelector
